<!--
  Full view of the dunning type object. Exactly ONE navigation point is rendered at a time, so a
  view costs exactly one child query instead of the ten the former tab strip fired at once.

  Three shapes:
    overview  — the read-only summary component,
    nodeView  — the graphical canvas,
    all rest  — the shared child table, driven by the descriptor from the base class.

  The node view branch deliberately carries NO top margin: the canvas sizes itself to
  `calc(100vh - 180px)`, an arithmetic that already accounts for the page chrome above it. Any extra
  margin here would push the canvas past the viewport and produce a second, outer scrollbar. The
  former `-mt-4` correction existed only to cancel the view switcher bar that sat above the canvas;
  that bar is gone, so the canvas now starts where it should and needs no correction at all.

  The canvas runs WITHOUT custom node templates. The two that used to be declared here (for
  bd.DunningTypeCharge and bd.DunningTypeManualTransaction) both printed `entity?.name`, a field
  NEITHER entity has — so every one of those nodes showed nothing but the literal fallback text
  "Gebühr" / "Manuelle Transaktion". The node view config now carries a correct `displayField` for
  both, and the built-in terminal title renders it including truncation and a hover tooltip, which
  the hand-written templates did not do. Deleting them is therefore both the fix and the smaller
  surface.
-->
@if (initialized && dto) {

    <div class="bd-dunning-type-full" [class.mt-4]="activeNavigationItem?.action != 'nodeView'">

        @if (activeNavigationItem?.action == 'overview') {

            <bd-dunning-type-overview
                    [dunningTypeId]="objectIdentifier.objectId"
                    [dunningTypeDto]="$any(dto)">
            </bd-dunning-type-overview>

        } @else if (activeNavigationItem?.action == 'nodeView') {

            <mvs-config-node-view
                    [config]="dunningTypeNodeViewConfig"
                    [rootEntityId]="objectIdentifier.objectId"
                    [rootEntityName]="dto?.['name'] || 'Mahnart'"
                    [rootEntityIcon]="dto?.['image'] || 'fa-solid fa-file-invoice-dollar'"
                    (onNodeSelect)="handleNodeSelect($event)"
                    (onAddChild)="handleAddChild($event)"
                    (onNodeEdit)="handleNodeEdit($event)"
                    (onBusyChange)="handleNodeBusyChange($event)">
            </mvs-config-node-view>

        } @else if (childTables[activeNavigationItem?.action]) {

            <bd-dunning-type-child-table
                    [dunningTypeId]="objectIdentifier.objectId"
                    [child]="childTables[activeNavigationItem.action]">
            </bd-dunning-type-child-table>

        }

    </div>

}
